import React, { useEffect, useState, useRef } from "react";
import { Row, Col } from "antd";
import { Card, Icon, LoadingSpinner, Modal, Button, ButtonGroup, Tooltip } from 'pepsico-ds'
import mi_service_catalogue from "../../../src/assets/mi-service-catalogue.svg";
import mi_sample_report from "../../../src/assets/mi-sample-report.svg";
import mi_request_report from "../../../src/assets/mi-request-report.svg";
import mi_inhouse_big_card_1 from "../../assets/mi-inhouse-big-card-1.png"
import mi_inhouse_big_card_2 from "../../assets/mi-inhouse-big-card-2.svg"
import chevron_right from "../../../src/assets/chevron_right.svg";
import { miInhouseUrls } from "../../mocks/miInhouseUrls";
import { useSelector } from "react-redux";
import { localStoreKeys } from '../../constants/localStoreKeys'
import { useDispatch } from 'react-redux'
import { FetchMarketIntelInHouseDetailAction } from '../../redux/action/MarketIntelAction'
import ModalFilters from './ModalFilters'
import { formatNumberWithCommas, returnHyphenIfNull, handleDomToImgDownloadPdf } from '../../utils/utils'
import InfoIcon from '../Icons/InfoIcon';
import { trackModalView, getModalAttributes } from '../../utils/fullstory-utils';
import DropdownWithIcons from "./DropdownWithIcons";
import { useToast } from '../../components/Toast/ToastContext';
import Vector from '../../assets/Vector.png'
import EDF_checked from "../../../src/assets/EDF_checked.svg";
import { staticNotes } from '../../constants/staticNotes';


const handleClick = (url) => {
    window.open(url, "_blank")
}
const commodityReportsUrl = window.MARKET_INTEL_COMM_REPORTS_URL;

const marketIntelInhouseData = {
    urls: {
        service_catalogue: "https://pepsico.sharepoint.com/sites/MarketIntelligence-ProjectRepository/SitePages/MI-Service-Catalogue(1).aspx?xsdata=MDV8MDJ8SXNoYWFuLktodW5nZXIuQ29udHJhY3RvckBwZXBzaWNvLmNvbXxhOTRkNjNmOTYzZTM0ZTg3YTc2NDA4ZGQxNTE2MDRhNnw0MmNjMzI5NWNkMGU0NDljYjk4ZTVjZTViNTYwYzFkM3wwfDB8NjM4Njg5OTA2NDkyODUyODYwfFVua25vd258VFdGcGJHWnNiM2Q4ZXlKRmJYQjBlVTFoY0draU9uUnlkV1VzSWxZaU9pSXdMakF1TURBd01DSXNJbEFpT2lKWGFXNHpNaUlzSWtGT0lqb2lUV0ZwYkNJc0lsZFVJam95ZlE9PXwwfHx8&sdata=bjhyWHJFUWh3N1dsM3lpeVRVa1AwT1A2MXduaSs3Y1VWdi9kckpqTkh3VT0%3D&CT=1734935056085&OR=OWA-NT-Mail&CID=e3e57693-3bc8-1f6e-6828-9579756216f6&clickParams=eyJYLUFwcE5hbWUiOiJNaWNyb3NvZnQgT3V0bG9vayBXZWIgQXBwIiwiWC1BcHBWZXJzaW9uIjoiMjAyNDEyMTMwMDIuMTAiLCJPUyI6IldpbmRvd3MgMTEifQ%3D%3D",
        mi_sample_report: "https://pepsico.sharepoint.com/:b:/r/sites/MarketIntelligence-ProjectRepository/Shared%20Documents/AMESA/DIRECT/Sustainable%20Packaging/rPET%20Market%20Study_AMESA_August%202024.pdf?csf=1&web=1&e=qQtERl&xsdata=MDV8MDJ8UmlzaGlrZXNoLlBhdGlsMS5Db250cmFjdG9yQHBlcHNpY28uY29tfGFjOWVkMmU4NDdhYzQ2MDU4NWVhMDhkZDI0MWNmYWUyfDQyY2MzMjk1Y2QwZTQ0OWNiOThlNWNlNWI1NjBjMWQzfDB8MHw2Mzg3MDY0MjkwNjIxNTE1MDl8VW5rbm93bnxUV0ZwYkdac2IzZDhleUpGYlhCMGVVMWhjR2tpT25SeWRXVXNJbFlpT2lJd0xqQXVNREF3TUNJc0lsQWlPaUpYYVc0ek1pSXNJa0ZPSWpvaVRXRnBiQ0lzSWxkVUlqb3lmUT09fDB8fHw%3d&sdata=QzUwRXdmVHdST05TTlI0TWlZbkFzU0xEOWw5SHZ1Y3B2Ym15WVZMbC9jMD0%3d",
        request_own_report: "https://forms.office.com/pages/responsepage.aspx?id=lTLMQg7NnES5jlzltWDB0yix0ztE8m5FvsgzPC_eCVtUOU00STZGVjZEMVZPOENKUTFUMVNTVkpOVy4u&route=shorturl",
        mi_repository: "https://pepsico.sharepoint.com/sites/MarketIntelligence-ProjectRepository/Shared%20Documents/Forms/AllItems.aspx",
        commodity_reports_repository: "https://pepsico.sharepoint.com/:u:/r/teams/AMESACOMMODITYDASHBOARD/SitePages/Home.aspx?csf=1&web=1&e=Xq9EKE",
        sample_commodity_report: "https://pepsico.sharepoint.com/:p:/r/sites/MarketIntelligence-ProjectRepository/Shared%20Documents/AMESA/COMMODITY%20DASHBOARD/SAMPLE_AMESA%20Commodity%20Monthly%20Report%20-%202024.pptx?d=w098cfbcf634c4e2b9f616fd598c076c3&csf=1&web=1&e=Qw18rh"
    },
    commodity_reports_contact: [
        "abhishek.sreedhar@pepsico.com",
        "niteesh.srivastava@pepsico.com"
    ]
}


function MiBigCard({ img, title, description, text, links, footer }) {
    return (
        <Card>
            <Row gutter={[10, 10]}>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <img src={img} className="mi-inhouse-big-card-img" />
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <div className="mi-inhouse-big-card-right-contianer">
                        <div className="mi-inhouse-big-card-title">{title}</div>
                        <div className="mi-inhouse-big-card-desc">{description}</div>
                        <div className="mi-inhouse-big-card-text">{text}</div>
                        {links.map(item => {
                            return <div className="mi-inhouse-big-card-link" onClick={() => window.open(item.url, "_blank")}>
                                <span>{item.title}</span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                                    <path d="M7.99935 3.16602L7.05935 4.10602L10.7793 7.83268H2.66602V9.16602H10.7793L7.05935 12.8927L7.99935 13.8327L13.3327 8.49935L7.99935 3.16602Z" fill="#005CBC" />
                                </svg>
                            </div>
                        })}
                    </div>
                </Col>
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                    {footer && <div className="mi-inhouse-big-card-footer">{footer}</div>}
                </Col>
            </Row>
        </Card>
    )
}
function MIInHouseCardNew({ mainHeader, image, subHeader, content, footerText, footerUrl }) {
    return (
        <>
            <div className="market-intel-container">
                <div className="mi-step-header">{mainHeader}</div>
                {/* <div className="mi-card-content"> */}
                <Row>
                    <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                        <div>
                            <div className="mi-inhouse-card-image">
                                <img src={image} className="mi_inhouse_card_2" alt="Sample Report" />
                            </div>
                        </div>
                    </Col>
                    <Col xs={24} sm={24} md={16} lg={16} xl={16}>
                        <div style={{ marginLeft: "16px", width: "100%" }}>
                            <div className="mi-inhouse-card-header">{subHeader}</div>
                            <div className="mi-inhouse-card-content">{content}</div>
                            {/* <div class="mi-button-footer">
                                    <div style={{display:"flex",cursor:"pointer"}} onClick={() => handleClick(footerUrl)}>{footerText} <Icon alt="" icon="arrow_forward" size="small"/></div>
                                </div> */}
                        </div>
                    </Col>
                </Row>
                <div className="mi-button-footer">
                    <div style={{ display: "flex", cursor: "pointer" }} onClick={() => handleClick(footerUrl)}>{footerText} <Icon alt="" icon="arrow_forward" size="small" /></div>
                </div>
                {/* </div> */}
            </div>
        </>
    )
}

function MIInHouseModalNew({ openModal, setOpenModal, userData, userDataLandingPage, selectedYear, landingPageFilters, capability, appName }) {


    const [buttonGroupItems, setButtonGroupItems] = useState([])
    const [loader, setLoader] = useState(true)
    // const marketIntelApps = JSON.parse(localStorage.getItem("marketIntelApps"))
    const marketIntelApps = useSelector((state) => state?.localData?.data[localStoreKeys.marketIntelInhouseApps]);
    // console.log(marketIntelApps)
    const feedbackFormUrl = useSelector((state) => state?.localData?.data[localStoreKeys.feedbackFormUrl]);
    const isLoading = useSelector((state) => state?.loader?.isLoading);


    
    const getMIInhouseDataFromFilters = (value) => {
        // console.log("spend value", value);
        setLoader(value.loader);
        if (marketIntelApps && marketIntelApps.length > 0) {
            const tempbuttonGroupItems =
                marketIntelApps
                    ?.filter(item => item.isActive)
                    .map(item => ({
                        label: item.app,
                        onClick: () => window.open(item.url, "_blank"),
                    }));

            setButtonGroupItems(tempbuttonGroupItems)
        }
    }
    // useEffect(() => {
    //     if (marketIntelApps && marketIntelApps.length > 0) {
    //         const tempbuttonGroupItems =
    //             marketIntelApps
    //                 ?.filter(item => item.isActive)
    //                 .map(item => ({
    //                     label: item.app,
    //                     onClick: () => window.open(item.url, "_blank"),
    //                 }));

    //         setButtonGroupItems(tempbuttonGroupItems)
    //     }
    // }
    //     , [])
    const dispatch = useDispatch()
    const miInHouseData = useSelector((state) => state.getMarketIntelInHouseDetailReducer);
    // useEffect(() => {
    //     dispatch(FetchMarketIntelInHouseDetailAction());
    // }, []);
    useEffect(() => {
        if (miInHouseData?.type === "SUCCESS_MARKET_INTEL_INHOUSE_DETAIL_VIEW_ACTION") {
            // console.log(miInHouseData)
        }
    }, [miInHouseData]);

        useEffect(() => {
            if (openModal) {
                try {
                    trackModalView(`${capability} ${appName}`, 'view');
                } catch (error) {
                    // Silent fail for tracking errors to not disrupt user experience
                }
            }
        }, [openModal, appName, capability]);
    
        const handleClose = () => {
            try {
                trackModalView(`${capability} ${appName}`, 'close');
            } catch (error) {
                // Silent fail for tracking errors
            }
            setOpenModal(false);
        };
    const appOwnersList = miInHouseData?.owners;
    const pageUrls = miInHouseData?.miDetails?.urls;
    const commodityReportContact = miInHouseData?.miDetails?.commodity_reports_contact?.join(' or ');
    const lastUpdate = returnHyphenIfNull(miInHouseData?.lastUpdate);
    const refreshFrequency = returnHyphenIfNull(miInHouseData?.refreshFrequency);
    const categoryReport = (miInHouseData?.categoryReport);
    const commodityReport = (miInHouseData?.commodityReport);
    const totalReport = (miInHouseData?.totalReport);
    const monthlyNewsLetterReport = (miInHouseData?.monthlyNewsLetterReport);
    const isEDFIntegrated = miInHouseData?.edfintegrated;

    const miInHouseRef = useRef()

    const { showToast } = useToast();


    
    const checkPDFDownloaded = () => {}

    return (
        <Modal
            //onCloseModal={() => setOpenModal(!openModal)}
            onCloseModal={handleClose}
            primaryButtonProps={{
                //onClick: () => setOpenModal(!openModal),
                onClick: handleClose,
                size: "medium",
                text: "Close",
                variant: "primary",
            }}
            showPrimaryButton={true}
            showLink={false}
            showSecondaryButton={false}
            showTertiaryButton={false}
            showAuxiliaryButton={false}
            showSlot={true}
            showModal={openModal}
            closeOnOutsideClick={false}
            hideCloseButton={false}
            type="XL"
            {...getModalAttributes(`${capability} ${appName}`)}
        >
            <div ref={miInHouseRef}>
                <div className="modal-title" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <span>
                        {userData?.FirstName}, total In-house MI Reports for your sector and category are <b>{formatNumberWithCommas(totalReport)}</b>
                        {
                            isEDFIntegrated &&
                            <Tooltip direction="bottom" text={staticNotes.EDF_NOTE}>
                                <img src={EDF_checked} alt='image' style={{ width: '18px', height: '22px', marginLeft: "8px", overflow:"visible", marginBottom: "7px" }} />
                            </Tooltip>
                        }
                    </span>
                    {/* <button onClick={() => handleDomToImgDownloadPdf(miInHouseRef, "MI_INHouse_Modal")}>PDF</button> */}
                    <span style={{float: 'right', position: 'relative', right: '2rem', bottom: '0.6rem'}}>
                        <DropdownWithIcons modalRef={miInHouseRef} kpiName={"MI_INHouse_Modal"} isModal={true} checkPDFDownloaded={checkPDFDownloaded}/>
                    </span>
                    {/* <ButtonGroup
                        style={{ marginRight: '2rem' }}
                        className="buy-con-button-group"
                        items={buttonGroupItems}
                        size="small"
                    /> */}
                </div>
                {/* <Row style={{ width: "100%" }}>
                    <Col xs={24} sm={24} md={7} lg={7} xl={7}>
                        <Card style={{ height: "100%" }}>
                            <MIInHouseCardNew></MIInHouseCardNew>
                        </Card>
                    </Col>
                    <Col xs={24} sm={24} md={2} lg={2} xl={2}>
                    </Col>
                    <Col xs={24} sm={24} md={7} lg={7} xl={7}>
                        <Card style={{height: "100%"}}>
                            <MIInHouseCardNew></MIInHouseCardNew>
                        </Card>
                    </Col>
                    <Col xs={24} sm={24} md={2} lg={2} xl={2}>
                    
                    </Col>
                    <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                        <Card style={{height: "100%"}}>
                            <MIInHouseCardNew></MIInHouseCardNew>
                        </Card>
                    </Col>
                </Row> */}


                {(miInHouseData?.lastUpdate) && <div className="modal-update-frequesncy">Data As On: {lastUpdate} | Refresh Frequency: {refreshFrequency}</div>}
                <ModalFilters selectedYear={selectedYear} capability={capability} userData={userDataLandingPage} onParentCallback={getMIInhouseDataFromFilters} landingPageFilters={landingPageFilters} setLoader={setLoader} appName={appName} />
                {
                    isLoading ?
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: 300 }}>
                            <LoadingSpinner size={{ height: '80px', width: '80px' }} />
                        </div>
                        :
                        <>
                            <div style={{ marginTop: 10, marginBottom: 10, display: 'flex', justifyContent: 'flex-start', width: '100%', flexDirection: "row" }}>
                                <Row gutter={[10, 10]} justify="start" style={{ width: "100%" }}>
                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                <Card style={{ height: '100%',display:'flex' }}>
                                    <div className='header-kpi-wrapper'>

                                    <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                                        <div>
                                            <div className="spend-modal-total-supplier">{formatNumberWithCommas(totalReport)}</div>
                                            <div className='spend-modal-manage-spend'>Total In-house MI Reports</div>
                                        </div>
                                    </Col>

                                    <div className="modal-divider-verticle" />
                                    <Col xs={24} sm={24} md={5} lg={5} xl={5}>
                                        <div>
                                            <div className="spend-modal-total-supplier">{formatNumberWithCommas(categoryReport)}</div>
                                            <div className='spend-modal-manage-spend'>Category MI reports</div>
                                        </div>
                                    </Col>

                                    <div className="modal-divider-verticle" />
                                    <Col xs={24} sm={24} md={5} lg={5} xl={5}>
                                        <div>
                                            <div className="spend-modal-total-supplier">{formatNumberWithCommas(monthlyNewsLetterReport)}</div>
                                            <div className='spend-modal-manage-spend'>Newsletters and ad-hoc reports</div>
                                        </div>
                                    </Col>
                                    <div className="modal-divider-verticle" />
                                    <Col xs={24} sm={24} md={5} lg={5} xl={5}>
                                        <div>
                                            <div className="spend-modal-total-supplier">{formatNumberWithCommas(commodityReport)}</div>
                                            <div className='spend-modal-manage-spend' style={{ display: "flex" }}><span style={{ marginRight: "4px" }}>Commodity Reports</span> <InfoIcon text="Restricted sector-wise access" /></div>
                                        </div>
                                    </Col>
                                    </div>
                                </Card>
                                </Col> 
                                </Row>
                            </div>
                            <br />
                            <Row gutter={[10, 10]} style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
                                {/* First Card */}
                                <Col style={{ width: "30%" }}>
                                    <Card style={{ height: "100%" }}>
                                        <MIInHouseCardNew
                                            mainHeader={"Step 1"}
                                            image={mi_service_catalogue}
                                            subHeader={"MI Service Catalogue"}
                                            content={"Discover the various MI reports the team can tailor for your specific needs."}
                                            footerText={"Explore MI Catalogue"}
                                            footerUrl={pageUrls?.service_catalogue}
                                        ></MIInHouseCardNew>
                                    </Card>
                                </Col>

                                <Col style={{ width: "5%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                    <img src={chevron_right} className="chevron_right" alt="" />
                                </Col>

                                <Col style={{ width: "30%" }}>
                                    <Card style={{ height: "100%" }}>

                                        <MIInHouseCardNew
                                            mainHeader={"Step 2"}
                                            image={mi_sample_report}
                                            subHeader={"Sample MI Report"}
                                            content={"Review one of the Sample MI Reports."}
                                            footerText={"View Sample Report"}
                                            footerUrl={pageUrls?.mi_sample_report}
                                        ></MIInHouseCardNew>
                                    </Card>
                                </Col>

                                <Col style={{ width: "5%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                    <img src={chevron_right} className="chevron_right" alt="" />
                                </Col>

                                <Col style={{ width: "30%" }}>
                                    <Card style={{ height: "100%" }}>

                                        <MIInHouseCardNew
                                            mainHeader={"Step 3"}
                                            image={mi_request_report}
                                            subHeader={"Request your own MI Report"}
                                            content={"Complete this form to request to request your own custom Market Intelligence report."}
                                            footerText={"Get Started"}
                                            footerUrl={pageUrls?.request_own_report}
                                        ></MIInHouseCardNew>
                                    </Card>
                                </Col>
                            </Row>
                            <br />
                            <Row gutter={[10, 10]} style={{ width: "100%" }}>
                                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                    <MiBigCard
                                        img={mi_inhouse_big_card_1}
                                        title={"Customized Market Intelligence Reports Repository"}
                                        description={"Access the comprehensive collection of customized Market Intelligence reports."}
                                        text="Accessible to all"
                                        links={[{ title: "Explore MI Repository", url: pageUrls?.mi_repository }]}
                                        footer={null}
                                    />
                                </Col>
                                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                    <MiBigCard
                                        img={mi_inhouse_big_card_2}
                                        title={"Sector-wise Commodity Reports Repository"}
                                        description={"Access the comprehensive collection of Commodity Reports."}
                                        text="Restricted sector-wise access"
                                        links={[{ title: "Explore Reports", url: pageUrls?.commodity_reports_repository }, { title: "View Sample Report", url: pageUrls?.sample_commodity_report }]}
                                        footer={"In case you are not able to access the Commodity Reports, please reach out to " + commodityReportContact}
                                    />
                                </Col>
                            </Row>
                            <br />
                            <div className="spend-modal-manage-spend" style={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center", width: '100%' }}>
                                <div style={{width: '100%'}}>Please reach out to {appOwnersList?.map((contact, index) => (
                                    <React.Fragment key={index}>
                                        <a href={`mailto:${contact.emailId}`} style={{ color: "#005cbc", textDecoration: "None" }}>{contact.emailId}</a>
                                        {index < appOwnersList.length - 1 && ', '}
                                    </React.Fragment>
                                ))} for any query on the data displayed.</div>
                                <div style={{width: '100%'}}>Please fill in <a href={feedbackFormUrl} target="_blank" style={{ color: "#005cbc", textDecoration: "None" }}>this form</a> for any feedback related to Procurement Hub.</div>
                            </div>
                            <br />

                        </>
                }
                <br/>
            </div>

        </Modal>
    )
}


export default MIInHouseModalNew